// extracted by mini-css-extract-plugin
module.exports = {"in-memoriam-list":"inMemoriam_in-memoriam-list__34Azb"};